import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import styled, {css} from 'styled-components'

export const StyledAgendaSidebarViewCardScrollArea = styled(ScrollArea)`
    max-height: 400px;
    width: 100%;
`

export const StyledAgendaSidebarViewContent = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing / 4}px ${spacing * 3}px ${spacing / 4}px ${spacing / 4}px;
    `
)
